/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomainThreat } from './DomainThreat';
import {
    DomainThreatFromJSON,
    DomainThreatFromJSONTyped,
    DomainThreatToJSON,
    DomainThreatToJSONTyped,
} from './DomainThreat';

/**
 * 
 * @export
 * @interface PaginatedDomainThreatList
 */
export interface PaginatedDomainThreatList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDomainThreatList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDomainThreatList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDomainThreatList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<DomainThreat>}
     * @memberof PaginatedDomainThreatList
     */
    results: Array<DomainThreat>;
}

/**
 * Check if a given object implements the PaginatedDomainThreatList interface.
 */
export function instanceOfPaginatedDomainThreatList(value: object): value is PaginatedDomainThreatList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedDomainThreatListFromJSON(json: any): PaginatedDomainThreatList {
    return PaginatedDomainThreatListFromJSONTyped(json, false);
}

export function PaginatedDomainThreatListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDomainThreatList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(DomainThreatFromJSON)),
    };
}

  export function PaginatedDomainThreatListToJSON(json: any): PaginatedDomainThreatList {
      return PaginatedDomainThreatListToJSONTyped(json, false);
  }

  export function PaginatedDomainThreatListToJSONTyped(value?: PaginatedDomainThreatList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(DomainThreatToJSON)),
    };
}

